const invoice = {
  invoiceMoreInfo: 'More Invoice Info',
  invoiceLocation: 'Lounge Location',
  invoiceCreator: 'Created By'
};

export default invoice;
